import * as Sentry from '@sentry/browser'

import { getTenant } from '@/helpers/tenant'

// Reports an unexpected API response, e.g. a non-OK status or a document of the wrong shape
export const reportMessage = (source: string, message: string): void => {
    Sentry.captureMessage(message, {
        extra: { source, tenant: getTenant() },
    })
}

// Reports a thrown error, both in the console and to Sentry
export const reportError = (source: string, error: unknown): void => {
    console.error(`[${source}]`, error)

    Sentry.captureException(error, {
        extra: { source, tenant: getTenant() },
    })
}
